module.exports = __webpack_public_path__ + "client/img/world_05.f372564d.png";